import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

import { InfoComponent } from '../shared-blog-module/blog-info/info.component';
import { ListingComponent } from '../shared-blog-module/blog-listing/listing.component';
import { AddComponent } from './add.component';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FlexLayoutModule } from '@angular/flex-layout';
import { SharedModule } from '../../../shared-module/shared.module';
import { TranslateModule } from '@ngx-translate/core';
import {
  MatButtonModule,
  MatCheckboxModule,
  MatFormFieldModule,
  MatInputModule,
  MatMenuModule,
  MatSelectModule,
  MatAutocompleteModule,
} from '@angular/material';
import { CustomMaterialModule } from '../../../core/material.module';
import { QuillModule } from 'ngx-quill';
import { NgxUploaderModule } from 'ngx-uploader';
import { ImageCropperModule } from 'ngx-image-cropper';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { LeafletModule } from '@asymmetrik/ngx-leaflet';
import { MatChipsModule } from '@angular/material/chips';
import { SharedBlogModule } from '../shared-blog-module';

const COMPONENTS = [AddComponent];

@NgModule({
  imports: [
    // From jobs
    MatMenuModule,
    DragDropModule,
    MatFormFieldModule,
    MatButtonModule,
    LeafletModule,
    MatInputModule,
    MatCheckboxModule,
    MatChipsModule,
    MatAutocompleteModule,

    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule,
    FlexLayoutModule,
    SharedModule,
    TranslateModule,
    MatSelectModule,
    CustomMaterialModule,
    QuillModule,
    NgxUploaderModule,
    ImageCropperModule,
    SharedBlogModule,
    RouterModule.forChild([
      {
        path: 'add',
        component: AddComponent,
        children: [
          {
            path: '',
            redirectTo: 'info',
            pathMatch: 'full',
          },
          {
            path: 'info',
            component: InfoComponent,
            pathMatch: 'full',
          },
          {
            path: 'listing',
            component: ListingComponent,
            pathMatch: 'full',
          },
        ],
      },
    ]),
  ],
  declarations: COMPONENTS,
  exports: COMPONENTS,
})
export class AddModule {}
